/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { getInsuranceLoanById, getAllAdmins } from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import moment from "moment";
import { FaEdit } from 'react-icons/fa';
import { Row, Col, Button } from "react-bootstrap";

const EditInsuranceViewModal = ({ isOpen, onClose, loanId }) => {
  const { adminId, adminName } = useContext(AuthContext);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const methods = useForm();
  const { register, setValue, clearErrors, watch } = methods;
  const [insuranceType, setInsuranceType] = useState("");
  const watchedInsuranceType = watch("insurance_type");

  useEffect(() => {
    if (watchedInsuranceType) {
      setInsuranceType(watchedInsuranceType);

      clearErrors();

      switch (watchedInsuranceType) {
        case "Health Insurance":
          setValue("patient_marital_status", "", { shouldValidate: true });
          setValue("health_insurance_coverage_amount", "", {
            shouldValidate: true,
          });
          setValue("co_name", "", { shouldValidate: true });
          setValue("co_dob", "", { shouldValidate: true });
          setValue("co_gender", "", { shouldValidate: true });
          setValue("co_mobile", "", { shouldValidate: true });
          break;
        case "General Insurance":
          setValue("general_insurance_policy_number", "", {
            shouldValidate: true,
          });
          setValue("general_insurance_provider", "", { shouldValidate: true });
          setValue("general_coverage_amount", "", { shouldValidate: true });
          break;
        case "Life Insurance":
          setValue("life_insurance_policy_number", "", {
            shouldValidate: true,
          });
          setValue("life_coverage_amount", "", { shouldValidate: true });
          setValue("policy_type", "", { shouldValidate: true });
          setValue("purpose_for_seeking", "", { shouldValidate: true });
          setValue("employment", "", { shouldValidate: true });
          setValue("occupation", "", { shouldValidate: true });
          setValue("annual_income", "", { shouldValidate: true });
          setValue("primary_name", "", { shouldValidate: true });
          setValue("primary_dob", "", { shouldValidate: true });
          setValue("primary_relationship", "", { shouldValidate: true });
          setValue("primary_percentage", "", { shouldValidate: true });
          setValue("secondary_name", "", { shouldValidate: true });
          setValue("secondary_dob", "", { shouldValidate: true });
          setValue("secondary_relationship", "", { shouldValidate: true });
          setValue("secondary_percentage", "", { shouldValidate: true });
          setValue("secondary_parent1", "", { shouldValidate: true });
          setValue("cause_of_death1", "", { shouldValidate: false });
          setValue("secondary_parent2", "", { shouldValidate: true });
          setValue("cause_of_death2", "", { shouldValidate: false });
          setValue("are_you_taking_medications", "", { shouldValidate: true });
          setValue("medication", "", { shouldValidate: true });
          setValue("any_bankruptcy", "", { shouldValidate: true });
          setValue("bankruptcy_explanation", "", { shouldValidate: false });
          setValue("medical_history", "", { shouldValidate: true });
          setValue("medical_history_explanations", "", {
            shouldValidate: false,
          });
          break;
        default:
          break;
      }
    }
  }, [watchedInsuranceType, setValue, clearErrors]);

  const [formData, setFormData] = useState({
    created_id: "",
    created_by: "",
    assigned_to: "",
    status: "",
    employee_type: "",
    rejected_reason: "",
    name: "",
    dob: "",
    age: "",
    gender: "",
    mobile1: "",
    mobile2: "",
    email: "",
    company_name: "",
    location: "",
    address_1: "",
    state: "",
    city: "",
    pincode: "",
    insurance_type: "",
    patient_marital_status: "",
    health_insurance_coverage_amount: "",
    co_name: "",
    co_dob: "",
    co_gender: "",
    co_mobile: "",
    general_insurance_policy_number: "",
    general_insurance_provider: "",
    general_coverage_amount: "",
    life_coverage_amount: "",
    policy_type: "",
    purpose_for_seeking: "",
    life_insurance_policy_number: "",
    employment: "",
    occupation: "",
    annual_income: "",
    primary_name: "",
    primary_dob: "",
    primary_percentage: "",
    primary_relationship: "",
    secondary_name: "",
    secondary_dob: "",
    secondary_percentage: "",
    secondary_relationship: "",
    secondary_parent1: "",
    cause_of_death1: "",
    secondary_parent2: "",
    cause_of_death2: "",
    are_you_taking_medications: "",
    medication: "",
    any_bankruptcy: "",
    bankruptcy_explanation: "",
    medical_history_explanations: "",
    medical_history: "",
    bankStatement: null,
    salarySlip: null,
    incomeCertificate: null,
  });

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await getAllAdmins();
        const filteredAgents = response.filter((admin) => admin.role === "employee");
        setAgents(filteredAgents);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching agents:", error);
      }
    };

    fetchAgents();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      if (loanId && isOpen) {
        try {
          const loan = await getInsuranceLoanById(loanId);
          setFormData({
            created_id: loan.created_id || "",
            created_by: loan.created_by || "",
            assigned_to: loan.assigned_to,
            status: loan.status,
            employee_type: loan.employee_type || "",
            rejected_reason: loan.rejected_reason || "",
            name: loan.name,
            age: loan.age.toString(),
            mobile1: loan.mobile1,
            mobile2: loan.mobile2,
            dob: loan.dob,
            gender: loan.gender,
            email: loan.email,
            company_name: loan.company_name,
            address_1: loan.address_1,
            location: loan.location,
            state: loan.state,
            city: loan.city,
            pincode: loan.pincode,
            insurance_type: loan.insurance_type,
            patient_marital_status: loan.patient_marital_status,
            health_insurance_coverage_amount:
              loan.health_insurance_coverage_amount,
            co_name: loan.co_name,
            co_dob: loan.co_dob,
            co_gender: loan.co_gender,
            co_mobile: loan.co_mobile,
            general_insurance_policy_number: loan.general_insurance_policy_number,
            general_insurance_provider: loan.general_insurance_provider,
            general_coverage_amount: loan.general_coverage_amount,
            life_coverage_amount: loan.life_coverage_amount,
            policy_type: loan.policy_type,
            purpose_for_seeking: loan.purpose_for_seeking,
            life_insurance_policy_number: loan.life_insurance_policy_number,
            employment: loan.employment,
            occupation: loan.occupation,
            annual_income: loan.annual_income,
            primary_name: loan.primary_name,
            primary_dob: loan.primary_dob,
            primary_percentage: loan.primary_percentage,
            primary_relationship: loan.primary_relationship,
            secondary_name: loan.secondary_name,
            secondary_dob: loan.secondary_dob,
            secondary_percentage: loan.secondary_percentage,
            secondary_relationship: loan.secondary_relationship,
            secondary_parent1: loan.secondary_parent1,
            cause_of_death1: loan.cause_of_death1,
            secondary_parent2: loan.secondary_parent2,
            cause_of_death2: loan.cause_of_death2,
            are_you_taking_medications: loan.are_you_taking_medications,
            medication: loan.medication,
            any_bankruptcy: loan.any_bankruptcy,
            bankruptcy_explanation: loan.bankruptcy_explanation,
            medical_history_explanations: loan.medical_history_explanations,
            medical_history: loan.medical_history,
            bankStatement: loan.bankStatement || null,
            salarySlip: loan.salarySlip || null,
            incomeCertificate: loan.incomeCertificate || null,
          });
        } catch (error) {
          console.error("Error fetching insurance loan data:", error);
        }
      }
    };

    fetchLoanData();
  }, [loanId, adminId, adminName]);

  const formattedDob = formData.dob
    ? moment(formData.dob).format("DD-MM-YYYY")
    : "";

  const formattedPrimaryDob = formData.primary_dob
    ? moment(formData.primary_dob).format("DD-MM-YYYY")
    : "";

  const formattedSecondaryDob = formData.secondary_dob
    ? moment(formData.secondary_dob).format("DD-MM-YYYY")
    : "";

  const formattedCoDob = formData.co_dob
    ? moment(formData.co_dob).format("DD-MM-YYYY")
    : "";

  const handleEditClick = () => {
    navigate(`/edit-insurance-loan/${loanId}`);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay-edit')) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-edit" onClick={handleOverlayClick}>
      <div className="modal-content-edit">
        <h3 className="edit-title">
          Insurance
          <span className="action-icon">
            <FaEdit
              className="edit-loan"
              style={{ cursor: 'pointer' }}
              onClick={handleEditClick}
            />
          </span>
        </h3>
        <div className="form-content-section">
          <div className="step-sections-personal-details-sections">
            <h4>Personal Details</h4>
            <div className="form-row-step">
              <strong>Agent ID:</strong>
              <div className="value">{formData.created_id}</div>
            </div>

            <div className="form-row-step">
              <strong>Agent:</strong>
              <div className="value">{formData.created_by}</div>
            </div>

            <div className="form-row-step">
              <strong>Assign to:</strong>
              <div className="value">{formData.assigned_to}</div>
            </div>

            <div className="form-row-step">
              <strong>Lead Status:</strong>
              <div className="value">{formData.status}</div>
            </div>

            {formData.status === "Rejected" && (
              <div className="form-row-step">
                <strong>Rejected reason:</strong>
                <div className="value">{formData.rejected_reason}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Name:</strong>
              <div className="value">{formData.name}</div>
            </div>

            <div className="form-row-step">
              <strong>Gender:</strong>
              <div className="value">{formData.gender}</div>
            </div>

            <div className="form-row-step">
              <strong>Date of Birth:</strong>
              <div className="value">{formattedDob}</div>
            </div>

            <div className="form-row-step">
              <strong>Age:</strong>
              <div className="value">{formData.age}</div>
            </div>

            <div className="form-row-step">
              <strong>Phone Number (Mobile):</strong>
              <div className="value">{formData.mobile1}</div>
            </div>

            <div className="form-row-step">
              <strong>Phone Number (Home):</strong>
              <div className="value">{formData.mobile2}</div>
            </div>

            <div className="form-row-step">
              <strong>Address Line 1:</strong>
              <div className="value">{formData.address_1}</div>
            </div>

            <div className="form-row-step">
              <strong>Email:</strong>
              <div className="value">{formData.email}</div>
            </div>

            <div className="form-row-step">
              <strong>State:</strong>
              <div className="value">{formData.state}</div>
            </div>

            <div className="form-row-step">
              <strong>City:</strong>
              <div className="value">{formData.city}</div>
            </div>

            <div className="form-row-step">
              <strong>Pincode:</strong>
              <div className="value">{formData.pincode}</div>
            </div>

            <div className="form-row-step">
              <strong>Employee Type:</strong>
              <div className="value">{formData.employee_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Insurance Type:</strong>
              <div className="value">{formData.insurance_type}</div>
            </div>

            <h4>Health Insurance Loan</h4>
            <div className="form-row-step">
              <strong>Patient Marital Status:</strong>
              <div className="value">{formData.patient_marital_status}</div>
            </div>

            <div className="form-row-step">
              <strong>Coverage Amount:</strong>
              <div className="value">{formData.health_insurance_coverage_amount}</div>
            </div>

            <div className="form-row-step">
              <strong>Name of Co-applicant:</strong>
              <div className="value">{formData.co_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Date of Birth :</strong>
              <div className="value">{formData.co_dob}</div>
            </div>

            <div className="form-row-step">
              <strong>Gender of Co-applicant:</strong>
              <div className="value">{formData.co_gender}</div>
            </div>

            <div className="form-row-step">
              <strong>Phone Number(Mobile) of Co-applicant:</strong>
              <div className="value">{formData.co_mobile}</div>
            </div>

            <h4>General Insurance Loan</h4>
            <div className="form-row-step">
              <strong>Policy Number:</strong>
              <div className="value">{formData.general_insurance_policy_number}</div>
            </div>

            <div className="form-row-step">
              <strong>Insurance Provider:</strong>
              <div className="value">{formData.general_insurance_provider}</div>
            </div>

            <div className="form-row-step">
              <strong>Coverage Amount:</strong>
              <div className="value">{formData.general_coverage_amount}</div>
            </div>

            <h4>Life Insurance Loan</h4>
            <div className="form-row-step">
              <strong>Coverage Amount:</strong>
              <div className="value">{formData.life_coverage_amount}</div>
            </div>

            <div className="form-row-step">
              <strong>Policy Type:</strong>
              <div className="value">{formData.policy_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Purpose for seeking insurance:</strong>
              <div className="value">{formData.purpose_for_seeking}</div>
            </div>

            <div className="form-row-step">
              <strong>Policy Number:</strong>
              <div className="value">{formData.life_insurance_policy_number}</div>
            </div>

            {/* <h4>Other Applicants to be covered - Partner/children</h4>
            <div className="form-row-step">
              <strong>Co-Name:</strong>
              <div className="value">{formData.co_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Co Date of Birth:</strong>
              <div className="value">{formattedCoDob}</div>
            </div>

            <div className="form-row-step">
              <strong>Co-Gender:</strong>
              <div className="value">{formData.co_gender}</div>
            </div>

            <div className="form-row-step">
              <strong>Co-Phone Number:</strong>
              <div className="value">{formData.co_mobile}</div>
            </div>





*/}


                <div className="form-row-step">
              <strong>Employment Status:</strong>
              <div className="value">{formData.employment}</div>
            </div>
            <div className="form-row-step">
              <strong>Occupation:</strong>
              <div className="value">{formData.occupation}</div>
            </div>
            <div className="form-row-step">
              <strong>Annual Income:</strong>
              <div className="value">{formData.annual_income}</div>
            </div> 
            <h4>Who do you want the proceeds to go to if you were to pass away?
              <span >Primary Beneficiaries (Must add up to 100%)</span>
            </h4>
            <div className="form-row-step">
              <strong>Primary Beneficiaries Name:</strong>
              <div className="value">{formData.primary_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Primary Beneficiaries Date of Birth:</strong>
              <div className="value">{formattedPrimaryDob}</div>
            </div>

            <div className="form-row-step">
              <strong>Primary Beneficiaries Relationship:</strong>
              <div className="value">{formData.primary_relationship}</div>
            </div>

            <div className="form-row-step">
              <strong>Primary Beneficiaries Percentage:</strong>
              <div className="value">{formData.primary_percentage}</div>
            </div>


            <h4>Secondary Beneficiaries (Must add up to 100%)</h4>
            <div className="form-row-step">
              <strong>Secondary Beneficiaries Name:</strong>
              <div className="value">{formData.secondary_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Secondary Beneficiaries Date of Birth:</strong>
              <div className="value">{formattedSecondaryDob}</div>
            </div>

            <div className="form-row-step">
              <strong>Secondary Beneficiaries Relationship:</strong>
              <div className="value">{formData.secondary_relationship}</div>
            </div>

            <div className="form-row-step">
              <strong>Secondary Beneficiaries Percentage:</strong>
              <div className="value">{formData.secondary_percentage}</div>
            </div>

            <div className="form-row-step">
              <strong>Parent 1:</strong>
              <div className="value">{formData.secondary_parent1}</div>
            </div>

            <div className="form-row-step">
              <strong>Cause of Death 1:</strong>
              <div className="value">{formData.cause_of_death1}</div>
            </div>

            <div className="form-row-step">
              <strong>Parent 2:</strong>
              <div className="value">{formData.secondary_parent2}</div>
            </div>

            <div className="form-row-step">
              <strong>Cause of Death 2:</strong>
              <div className="value">{formData.cause_of_death2}</div>
            </div>

            <div className="form-row-step">
              <strong>Are You taking any Medications:</strong>
              <div className="value">{formData.are_you_taking_medications}</div>
            </div>

            <div className="form-row-step">
              <strong>Medications and Dosage:</strong>
              <div className="value">{formData.medication}</div>
            </div>

            <div className="form-row-step">
              <strong>Any Bankruptcy?</strong>
              <div className="value">{formData.any_bankruptcy}</div>
            </div>

            <div className="form-row-step">
              <strong>Bankruptcy Explanation:</strong>
              <div className="value">{formData.bankruptcy_explanation}</div>
            </div>

            <div className="form-row-step">
              <strong>Medical history:  Have you ever been told you had, or been treated for any of the following conditions? Only check if yes.:</strong>
              <div className="value">{formData.medical_history}</div>
            </div>

            <div className="form-row-step">
              <strong>Medical History Explanations:</strong>
              <div className="value">{formData.medical_history_explanations}</div>
            </div>
          </div>

          <div className="button-sections">
            <Row>
              <Col className="text-end">
                <Button
                  className="custom-back-button"
                  type="button"
                  onClick={onClose}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditInsuranceViewModal;